import { CopyButton } from '../CopyButton/CopyButton';
import './CodeBlock.scss';

interface CodeBlockProps {
  content: string;
  language?: string;
}

export function CodeBlock({ content, language }: CodeBlockProps) {
  return (
    <div className="code-block">
      <div className="code-block__header">
        {language && <span className="code-block__language">{language}</span>}
        <CopyButton text={content} label="Copy" />
      </div>
      <pre className="code-block__pre">
        <code className="code-block__code">{content}</code>
      </pre>
    </div>
  );
}
